import { EntityAdapter, EntityState, createEntityAdapter } from '@ngrx/entity';
import { Action, ActionReducer, createReducer, on } from '@ngrx/store';
import { Method } from '@lyceo/lyceo-pupil-app/practise/util-models';
import { MethodActions } from './method.actions';
import { CallState, LoadingState } from '@lyceo/shared/util-loading';
import { ScopeActions } from '../scope/scope.actions';
import { mapMethodsForScopeToMethods } from './method.functions';
import { SettingsActions } from '@lyceo/lyceo-pupil-app/user/data-access';
import { AuthActions } from '@lyceo/shared/auth/data-access';

export const METHOD_FEATURE_KEY: string = 'method';

export interface MethodState extends EntityState<Method> {
  scopeMethodsCallState: CallState;
}

export const methodAdapter: EntityAdapter<Method> =
  createEntityAdapter<Method>();

export const initialMethodState: MethodState = methodAdapter.getInitialState({
  scopeMethodsCallState: LoadingState.INIT,
});

const reducer: ActionReducer<MethodState, Action> = createReducer(
  initialMethodState,
  on(AuthActions.logoutSuccess, (): MethodState => initialMethodState),
  on(
    SettingsActions.updateLevelYearSuccess,
    (state): MethodState =>
      methodAdapter.removeAll({
        ...state,
        scopeMethodsCallState: LoadingState.INIT,
      }),
  ),
  on(
    ScopeActions.getPersonScopesSuccess,
    (state): MethodState => ({
      ...state,
      scopeMethodsCallState: LoadingState.LOADING,
    }),
  ),
  on(
    MethodActions.getMethodsForScopeSuccess,
    (state, action): MethodState =>
      methodAdapter.upsertMany(
        mapMethodsForScopeToMethods(action.methodsForScopeDto),
        {
          ...state,
          scopeMethodsCallState: LoadingState.LOADED,
        },
      ),
  ),
  on(
    MethodActions.getMethodsForScopeFailure,
    (state, { error }): MethodState => ({
      ...state,
      scopeMethodsCallState: { errorMsg: error.message },
    }),
  ),
);

export function methodReducer(
  state: MethodState | undefined,
  action: Action,
): MethodState {
  return reducer(state, action);
}
